import React from 'react'
import { Image, ImageBackground, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Button, Screen, Text } from '@components'
import { ScreenAuthProps } from '@navigation'
import { iconApp, welcomeImage } from '@assets'
import { useLanguage } from '@context'
import getStyle from './style'
import { getCommonStyles } from '@utils'
import { useScreen } from '@hooks'

export const Welcome: React.FC<ScreenAuthProps<'Welcome'>> = ({ navigation }) => {
  const { t } = useLanguage()
  const { top } = useSafeAreaInsets()

  const theme = useTheme()
  const {isMobile} = useScreen()
  const styles = getStyle(theme, top)
  const commonStyles = getCommonStyles(theme)

  return (
    <Screen noPaddingTop noPaddingBottom>
      <ImageBackground source={welcomeImage} style={styles.container}>
        <View style={styles.topContainer}>
          <Image source={iconApp} style={styles.iconApp} />
          <Text type="titleBold" color={theme.colors.primary} style={styles.keeptouchTitle}>
            {t('welcome.title')}
          </Text>
          <Text type='bodySmallBold'>{t('welcome.tagline')}</Text>
        </View>

        <View style={[styles.bottomContainer, !isMobile && commonStyles.flexMaxAuth]}>
          <Button
            title={t('welcome.connection')}
            onPress={() => navigation.navigate('Login')}
            borderWhite
          />
          <Button
            title={t('welcome.registration')}
            unfilled
            onPress={() => navigation.navigate('Register')}
            containerStyle={styles.registerButton}
          />
          <Text type="body" color={theme.colors.white} style={styles.bottomText}>
            {t('welcome.slogan')}
          </Text>
        </View>
        <View />
      </ImageBackground>
    </Screen>
  )
}
